import React, { useState } from "react";
import {
  FormControl,
  Grid,
  TextField,
  IconButton,
  Box,
  Modal,
  Tooltip,
  MenuItem,
  Drawer,
  Button,
} from "@mui/material";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ApiEndpoints from "../network/ApiEndPoints";
import { get, postJsonData } from "../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
  overflowY: "scroll",
};

const EditMerchant = ({ row, refresh }) => {
  const [open, setOpen] = React.useState(false);

  const [request, setRequest] = useState(false);

  const EditMerchantModal = (event) => {
    event.preventDefault();
    const data = {
      id: row?.id,
      merchant_id: formData?.merchant_id,
      merchant_secret: formData?.merchant_secret,
    };
    setRequest(true);
    postJsonData(
      ApiEndpoints.UPDATE_MERCHANT,
      data,
      setRequest,
      (res) => {
        okSuccessToast(res?.data?.message || res?.message);
        handleClose();
        if (refresh) refresh();
      },
      (error) => {
        apiErrorToast(error);
      },
    );
  };

  const handleOpen = () => {
    setFormData({
      merchant_id: row?.merchant_id || row?.merchnat_id || "",
      merchant_secret: row?.merchant_secret || "",
    });

    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [formData, setFormData] = useState({
    merchant_id: row?.merchant_id || row?.merchnat_id || "",
    merchant_secret: row?.merchant_secret || "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
      }}
    >
      <Tooltip title="Edit Merchant">
        <Button
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "8px",
            fontSize: "12px",
            color: "#ffffff",
            fontWeight: "700",
            borderRadius: "8px  ",
            transition: "all 0.3s ease",
            justifyContent: "center",
            background: "#00693E",
            "&:hover": {
              backgroundColor: "#122480",
            },
          }}
          onClick={handleOpen}
        >
          Edit
        </Button>
      </Tooltip>

      <Drawer open={open} onClose={handleClose} anchor="right">
        <Box sx={{ width: 400 }} className="sm_modal">
          <ModalHeader
            title="Edit Merchant"
            handleClose={handleClose}
            subtitle="Easily Update Your Information Today."
          />
          <Box
            component="form"
            id="update-merchant"
            noValidate
            autoComplete="off"
            onSubmit={EditMerchantModal}
            sx={{
              "& .MuiTextField-root": { m: 2 },
            }}
          >
            <Grid container sx={{ pt: 1 }}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="User ID"
                    value={row.user_id}
                    size="small"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Merchant ID"
                    id="merchant_id"
                    size="small"
                    value={formData.merchant_id}
                    onChange={handleInputChange}
                    required
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Merchant Secret"
                    id="merchant_secret"
                    size="small"
                    value={formData.merchant_secret}
                    onChange={handleInputChange}
                    required
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Box sx={{ mr: "5px" }}>
              <ModalFooter
                form="update-merchant"
                request={request}
                btn="Edit Merchant"
              />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};
export default EditMerchant;
